<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            menu-trigger="hover"
            background-color="#fff"
            text-color="#666"
            :active-text-color="computedActiveTextColor"
            unique-opened
            router
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index" v-if="item.checked">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title" class="slide-title">{{ item.title }}</span>
                        </template>
                        <template v-for="(subItem, index) in item.subs">
                            <el-submenu
                                v-if="subItem.subs && subItem.checked"
                                :index="subItem.index"
                                :key="subItem.index"
                                class="two-slide"
                            >
                                <div slot="title">
                                    {{ subItem.title }}
                                </div>

                                <el-menu-item
                                    v-for="(threeItem, i) in subItem.subs"
                                    :key="i"
                                    :index="threeItem.index"
                                    v-if="threeItem.checked"
                                >
                                    {{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>

                            <!-- 二级 -->
                            <div v-else>
                                <el-menu-item v-if="subItem.index == 'driverAll' && subItem.checked" @click="toDriverAll">
                                    司机调度
                                </el-menu-item>

                                <el-menu-item
                                    v-if="subItem.index != 'driverAll' && subItem.checked"
                                    :index="subItem.index"
                                    :key="subItem.index"
                                    >{{ subItem.title }}
                                </el-menu-item>
                            </div>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index" v-if="item.checked">
                        <i :class="item.icon"></i>
                        <!-- <span slot="title" :class="{titleStr=='HAIKOU'?'slide-active':'slide-title'}">{{ item.title }}</span> 错误写法-->
                        <!-- <span slot="title" :class="{'slide-active':titleStr=='HAIKOU','slide-title':titleStr!='HAIKOU'}">{{ item.title }}</span> -->


                        <!-- 与上行代码同效果的两种写法 -->
                        <span slot="title" :class="{'slide-active':titleStr=='HAIKOU'}" class="slide-title">{{ item.title }}</span>  

                        <!-- <span slot="title" class="slide-title">{{ item.title }}</span> 原代码-->

                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
let _this;
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: false,
            computedActiveTextColor: '#fe6114',
            titleStr: '',

            items: []
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        _this = this;

        this.items = JSON.parse(sessionStorage.getItem('navBar'));
        _this.titleStr = JSON.parse(localStorage.getItem('cityInfo')).city_tag;
        if (_this.titleStr == 'HAIKOU') {
            _this.computedActiveTextColor = '#1BA1FF';
        }

        // // 如果导航缓存存在则赋值，否则请求接口获取导航
        // if (sessionStorage.getItem('navBar')) {
        //
        //     this.items = JSON.parse(sessionStorage.getItem('navBar'));
        //
        //     // this.$router.addRoutes([...routerData])
        //
        //
        // } else {
        //
        //     this.$post(
        //         "/system/getMenuDetails", {
        //             admin_role_code: JSON.parse(localStorage.getItem('login')).admin_role_code
        //         }
        //     ).then(res => {
        //
        //         this.items = res.data;
        //
        //         // console.log(JSON.stringify(res.data));
        //
        //         sessionStorage.setItem('navBar', JSON.stringify(res.data));
        //
        //     })
        //
        // }

        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', (msg) => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    },
    methods: {
        toDriverAll() {
            let routeData = this.$router.resolve({
                path: '/driverAll'
            });
            window.open(routeData.href, '_blank');
        }
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
    background-color: #fff;
    box-sizing: border-box;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 260px;
}

.sidebar > ul {
    border: 0;
}

.left-enter,
.left-leave-to {
    transform: translate3d(-100%, 0, 0);
    opacity: 0;
}

.left-leave,
.left-enter-to {
    transform: translate3d(0, 0, 0);
}

.left-enter-active,
.left-leave-active {
    transition: opacity 0.5s;
}

.el-submenu .el-menu-item {
    min-width: 0;
}

.iconfont {
    position: relative;
}

.iconfont::before {
    width: 10px;
    position: absolute;
    left: 1px;
    top: -100%;
}


/* 原代码 */
/* .el-menu-item.is-active .slide-title {
    color: #fe6114 !important;
} */


/* 新代码 去掉important，如果是多类名，小琳代驾权重高*/
.el-menu-item.is-active .slide-title {
    color: #fe6114;
}
.el-menu-item.is-active .slide-active {
    /* 小琳代驾样式 */
    color: #1BA1FF !important; 
}


.slide-title {
    display: block;
    text-indent: 25px;
}
.slide-active{
    /* 小琳代驾样式 动态类名 vue动态绑定class */

    display: block;
    text-indent: 25px;

}
</style>
